import {
  type LanguageCode,
  type CountryCode,
} from "@shopify/hydrogen-react/storefront-api-types";
import useSWR from "swr/immutable";

import getProductSizeGuideDataByID from "@graphql/get-product-size-guide-data-by-id.graphql";
import { multiStorefrontAPIFetcher } from "@react/hooks/fetchers";
import {
  type StandardizedSizeGuideData,
  type SizeGuideDataConnection,
} from "@root/tablescape/state";
import { formatProductSizeGuideData } from "@root/tablescape/utilities";
import { STOREFRONT_API_URL } from "@tablescape/constants";

type ProductSizeGuideConnection = {
  data?: {
    product?: SizeGuideDataConnection;
  };
};

const useProductSizeGuideParams = [
  STOREFRONT_API_URL,
  getProductSizeGuideDataByID,
];

export function useProductSizeGuide({
  country,
  language,
  productIds,
}: {
  country: CountryCode;
  language: LanguageCode;
  productIds: string[] | undefined;
}) {
  const { data: productSizeGuideReponses } = useSWR<
    ProductSizeGuideConnection[]
  >(
    productIds && country
      ? productIds.map((id) => [
          ...useProductSizeGuideParams,
          {
            id,
            country,
            language,
          },
        ])
      : null,
    multiStorefrontAPIFetcher
  );

  return (
    productSizeGuideReponses?.reduce<StandardizedSizeGuideData[][]>(
      (acc, data) => [
        ...acc,
        ...(data?.data?.product?.sizeGuide?.references?.nodes?.length
          ? [formatProductSizeGuideData(data.data.product)]
          : []),
      ],
      []
    ) ?? undefined
  );
}
